import { EventEmitter, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject ,  Subscription ,  BehaviorSubject, pipe } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


export interface FormValidity {
  isValid: boolean;
  invalidForms?: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {
  // todo: this should be removed
  phoneFormHasErrors = new Subject<boolean>();
  phoneFormHasErrors$ = this.phoneFormHasErrors.asObservable();

  formsValidity = new BehaviorSubject<FormValidity>({isValid: true});
  formsValidity$ = this.formsValidity.asObservable();

  touchForms = new EventEmitter();

  private formsList: { [key: string]: FormGroup };
  private subsctiptionsList: Subscription[];

  constructor() {
    this.formsList = {};
    this.subsctiptionsList = [];
  }

  /**
   * Register form for track validation state
   * @param key form identifier
   * @param form FormGroup
   */
  registerForm(key: string, form: FormGroup) {
    this.formsList[key] = form;
    this.subsctiptionsList.push(form.valueChanges.pipe(debounceTime(500)).subscribe(() => this.checkValidity()));
  }

  /**
   * Clear form validity tracking
   */
  clearForms() {
    this.subsctiptionsList.forEach((sub) => {
      sub.unsubscribe();
    });
    this.formsList = {};
  }

  // todo: this should be removed
  updatePhoneFormHasErrors(formHasErrors) {
    this.phoneFormHasErrors.next(formHasErrors);
  }

  private checkValidity() {
    let isValid = true;
    const invalidForms = [];
    for (const formname in this.formsList) {
      if (!this.formsList[formname].valid) {
        isValid = false;
        invalidForms.push(formname);
      }
    }
    const oldValidity = this.formsValidity.getValue();
    if (isValid !== oldValidity.isValid || (isValid === false && oldValidity.invalidForms.length !== invalidForms.length)) {
      this.formsValidity.next({ isValid, invalidForms });
    }
  }

}
